import { axiosInstance } from '@/services/axiosInstance'

export const MerchantsResource = {
  getLista: (parametros) => {
    return axiosInstance.get(
      'v1/Merchant',
      {
        params: parametros
      }
    )
  },

  getPendingInformation: (parametros) => {
    return axiosInstance.get(
      'v1/Merchant/pendinginformation',
      {
        params: parametros
      }
    )
  },

  getPendingFiles: (parametros) => {
    return axiosInstance.get(
      'v1/Merchant/PendingFiles',
      {
        params: parametros
      }
    )
  },

  getPendingFilesByMerchant: (parametros) => {
    return axiosInstance.get(
      'v1/Merchant/:idMerchant/PendingFiles', {
      urlParams: parametros
    }
    )
  },

  generateContract: (parametros) => {
    return axiosInstance.post(
      'v1/Merchant/' + parametros.idMerchant + '/contract', {
      urlParams: parametros
    }
    )
  },


  getKeyValue: (parametros) => {
    return axiosInstance.get(
      'v1/merchant/keyvalue',
      {
        params: parametros
      }
    )

  },

  getMerchantStatus: (parametros) => {
    return axiosInstance.get('v1/MerchantStatus', {
      params: parametros
    })
  },

  getMerchant: (parametros) => {
    return axiosInstance.get(
      'v1/Merchant/:idMerchant', {
      urlParams: parametros
    }
    )
  },

  getMerchantWithBank: (parametros) => {
    return axiosInstance.get(
      'v1/Merchant/:idMerchant/withbank', {
      urlParams: parametros
    }
    )
  },


  getMerchantAccountBankInfo: (parametros) => {
    return axiosInstance.get(
      'v1/Merchant/:idMerchant/bankaccountinfo', {
      urlParams: parametros
    }
    )
  },

  registerMerchant: (parametros) => {
    return axiosInstance.post('v1/Merchant',
      parametros
    )
  },
  updateMerchant: (parametros) => {
    return axiosInstance.put('v1/Merchant',
      parametros
    )
  },
}